import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProductsHero() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="http://geel.fp.08wx.cn/images/bb2bf326f6b1cf20f01b94fde4296c6f.jpg"
          alt="Products Hero"
          className="w-full h-full object-cover object-top opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/30 to-white" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-transparent to-white/90" />
      </div>

      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,45,120,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,45,120,1) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 py-20 md:py-32">
        <div className="flex items-center gap-2 mb-8">
          <Link to="/" className="text-xs text-gray-400 hover:text-primary transition-colors">{t('breadcrumb.home')}</Link>
          <i className="ri-arrow-right-s-line text-gray-300 text-sm" />
          <span className="text-xs text-primary">{t('breadcrumb.products')}</span>
        </div>

        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="text-primary text-xs font-medium uppercase tracking-widest">{t('productsPage.hero.tag')}</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-heading font-black text-gray-900 mb-6 leading-tight">
            {t('productsPage.hero.title')}
            <br />
            <span className="text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(135deg, #FF2D78 0%, #FF8FAB 100%)' }}>
              {t('productsPage.hero.highlight')}
            </span>
          </h1>

          <p className="text-gray-500 text-lg leading-relaxed max-w-2xl mb-10">
            {t('productsPage.hero.desc1')}
            {t('productsPage.hero.desc2')}
          </p>

          <div className="flex flex-wrap gap-3">
            {[
              { icon: 'ri-exchange-dollar-line', label: t('productsPage.hero.chip.cex'), path: '/products/cex' },
              { icon: 'ri-building-line', label: t('productsPage.hero.chip.rwa'), path: '/products/rwa' },
              { icon: 'ri-wallet-3-line', label: t('productsPage.hero.chip.wallet'), path: '/products/wallet' },
              { icon: 'ri-stack-line', label: t('productsPage.hero.chip.defi'), path: '/products/defi' },
              { icon: 'ri-cpu-line', label: t('productsPage.hero.chip.mining'), path: '/products/mining' },
            ].map((item, i) => (
              <Link
                key={i}
                to={item.path}
                className="flex items-center gap-2 px-4 py-2 bg-white border border-primary/20 hover:border-primary/50 text-gray-500 hover:text-primary text-xs rounded-full transition-all duration-200 cursor-pointer"
              >
                <i className={`${item.icon} text-sm`} />
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent pointer-events-none" />
    </section>
  );
}
